"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getGetCurrentUserQueryKey, logoutUser } from "@/app/generated/api/auth/auth";
import { authorizeClientPortalIdentity, getGetPublicClientPortalQueryKey, getPublicClientPortal } from "@/app/generated/api/client-portal/client-portal";
import { useCurrentUserSession } from "@/app/modules/auth/hooks/useCurrentUserSession";

export function useClientPortalIdentity(slug: string | null, enabled: boolean) {
  const session = useCurrentUserSession({ enabled });
  const portal = useQuery({ queryKey: getGetPublicClientPortalQueryKey(slug ?? ""), queryFn: () => getPublicClientPortal(slug!), retry: false, enabled: enabled && slug !== null });
  const authorize = useMutation({ mutationFn: (challenge: string) => authorizeClientPortalIdentity({ slug, challenge }) });
  const client = useQueryClient();
  const logout = useMutation({ mutationFn: () => logoutUser(), onSuccess: async () => {
    client.removeQueries({ queryKey: getGetCurrentUserQueryKey() });
    await session.refetch();
  } });
  return { session, portal, authorize, logout };
}
